import { jsx as i } from "react/jsx-runtime";
import { c as p } from "react/compiler-runtime";
import { TableBody as s } from "@mui/material";
import { forwardRef as f } from "react";
const b = f((l, m) => {
  const o = p(7);
  let r, e;
  o[0] !== l ? ({
    children: r,
    ...e
  } = l, o[0] = l, o[1] = r, o[2] = e) : (r = o[1], e = o[2]);
  let t;
  return o[3] !== r || o[4] !== e || o[5] !== m ? (t = /* @__PURE__ */ i(s, { ref: m, ...e, children: r }), o[3] = r, o[4] = e, o[5] = m, o[6] = t) : t = o[6], t;
});
export {
  b as TableBody
};
